import React from 'react'
import { utils } from '@/utils'

interface IconProps {
  prefix?: string
  name: string
  size?: string | number
  color?: string
  className?: string
  onClick?: () => void
}

const { px2rem } = utils

const Icon: React.FC<IconProps> = ({
  prefix = 'icon',
  name,
  size = 40,
  color = '#333',
  className,
  onClick,
}) => {
  const symbolId = `#${prefix}-${name}`
  const sizeText = px2rem(Number(size))

  return (
    <svg
      className={className}
      aria-hidden="true"
      style={{ width: sizeText, height: sizeText, color }}
      onClick={onClick}
    >
      <use href={symbolId} fill={color} />
    </svg>
  )
}

export default Icon
